module.exports = __webpack_public_path__ + "static/media/avatar-3.f552bde5.png";